<template>
  <div v-loading="isLoading" style="min-height: 400px">
    <div class="rj-page-card__title">
      基本信息
    </div>
    <div class="rj-row">
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            电汇编号：
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.telegraphicTransferNum }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            汇入公司：
          </div>
          <div v-if="telegraphicTransfer.account == '672083110110001'" class="rj-baseinfo__item">
            锐捷网络股份有限公司
          </div>
          <div v-else-if="telegraphicTransfer.account == '861384337810001'" class="rj-baseinfo__item">
            北京星网锐捷网络技术有限公司
          </div>
          <div v-else-if="telegraphicTransfer.account == '121929768910802'" class="rj-baseinfo__item">
            上海锐山网络有限公司
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            币种：
          </div>
          <div class="rj-baseinfo__item">
            人民币
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            客户名称：
          </div>
          <div v-if="telegraphicTransfer.newImportCompany" class="rj-baseinfo__item">
            {{ telegraphicTransfer.newImportCompany }}
          </div>
          <div v-else class="rj-baseinfo__item">
            {{ telegraphicTransfer.importCompany }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            汇款日期：
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.remittanceDate }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            汇款金额：
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.remittanceAmount }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            汇入行：
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.importBank }}
          </div>
        </div>
      </div>

      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            汇入账户：
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.account }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            状态：
          </div>
          <div class="rj-baseinfo__item">
            已到账
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            备注：
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.summary }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            可用余额：
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.unusedAmount }}
          </div>
        </div>
      </div>
    </div>
    <div class="rj-page-card__title" style="margin-top: 15px">
      电汇所指订单列表
    </div>
    <!-- <div>金额小计：<span class="money">{{ totalAssignAmount }}元</span></div> -->
    <el-table :data="tableData" border style="width: 100%;margin-top: 10px">
      <el-table-column type="index" width="60" label="序号" align="left" fixed="left" />
      <el-table-column prop="contractNum" label="锐捷电子商务合同编号" align="left" fixed="left" width="150" />
      <el-table-column prop="erpOrderNum" label="分配订单号" align="left" />
      <el-table-column prop="orderNetSale" label="订单总金额" align="right" header-align="left" />
      <el-table-column prop="assignAmount" label="本次分配金额" align="right" header-align="left" />
      <el-table-column prop="assignDate" label="分配日期" align="left" width="140px" />
      <el-table-column prop="abandon" label="状态" align="left" width="100px" />
    </el-table>
  </div>
</template>
<script type="es6">
import { selectModelByTelegraphicTransferNum } from '@/API/index';
export default {
  data () {
    return {
      tableData: [],
      isLoading: false,
      telegraphicTransfer: [],
      totalAssignAmount: 0
    };
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {},
  computed: {},
  methods: {
    selectDetail () {
      this.isLoading = true;
      selectModelByTelegraphicTransferNum(this.id).then((res) => {
        this.isLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.contractAssignGroup;
          this.telegraphicTransfer = json.data.telegraphicTransfer;
          this.totalAssignAmount = json.data.totalAssignAmount;
        }
      }).catch((res) => {
        this.isLoading = false;
      });
    }
  },
  mounted () {
    this.selectDetail();
  }
};
</script>
<style lang="scss">
  .money{
    color: #f60;
  }
</style>
